import config from 'config'
import store from 'store'
import AxSemanticsClient from 'axsemantics'

const api = {
	idm: null,
	init (token) {
		api._axsemantics = new AxSemanticsClient({
			idmBaseUrl: config.api.idm.baseUrl,
			idToken: token,
			fetch: function () {
				return AxSemanticsClient.fetch.apply(this, arguments).then((arg) => {
					return Promise.resolve(arg)
				}).catch((error) => {
					if (error.response && (error.response.status < 400 || error.response.status > 499)) { // let the caller handle 4xx
						store.commit('messaging/GENERIC_REQUEST_FAILED', error)
					}
					return Promise.reject(error)
				})
			}
		})

		api.idm = api._axsemantics._idm

		api.idm.users.list = () => {
			return api.idm.fetch('userlist/')
		}
		api.idm.users.get = (id) => {
			return api.idm.fetch(`userlist/${id}/`)
		}
		api.idm.users.impersonate = (id) => {
			return api.idm.fetch(`userlist/${id}/impersonate/`)
		}
	}
}

window.api = api // for console debug
export default api
